export type UserRole = "parent" | "child";

export type MoneyRequestType = "deposit" | "withdrawal";

export type MoneyRequestStatus =
  | "pending"
  | "approved"
  | "denied"
  | "expired"
  | "failed";

export type LedgerEntryType =
  | "deposit"
  | "withdrawal"
  | "parent_adjustment"
  | "investment_buy"
  | "investment_sell"
  | "investment_return";

export type RiskLevel = "low" | "medium" | "high";

export const INVESTMENT_RESULT_INTERVAL_SECONDS = 24 * 60 * 60;
export const INVESTMENT_RESULTS_PER_WEEK = 7;

export interface AuthUser {
  id: string;
  role: UserRole;
  displayName: string;
  email: string | null;
  username: string | null;
}

export interface AccountSummary {
  id: string;
  displayName: string;
  currency: "USD";
}

export interface ChildAccountDto {
  id: string;
  accountId: string;
  displayName: string;
  username: string;
  accountName: string;
  createdAt: string;
}

export interface BalanceSummary {
  cashCents: number;
  investedCents: number;
  totalCents: number;
}

export interface LedgerEntryDto {
  id: string;
  type: LedgerEntryType;
  amountCents: number;
  description: string;
  instrumentName: string | null;
  createdAt: string;
}

export interface MoneyRequestDto {
  id: string;
  type: MoneyRequestType;
  amountCents: number;
  note: string | null;
  status: MoneyRequestStatus;
  failureReason: string | null;
  childName?: string;
  accountName?: string;
  createdAt: string;
  reviewedAt: string | null;
}

export interface InstrumentDto {
  id: string;
  name: string;
  description: string;
  riskLevel: RiskLevel;
  minWeeklyReturnBps: number;
  maxWeeklyReturnBps: number;
  lossProbabilityBps: number;
  maxWeeklyLossBps: number;
}

export interface HoldingDto {
  instrumentId: string;
  instrumentName: string;
  riskLevel: RiskLevel;
  principalCents: number;
  currentValueCents: number;
  lastResultAt: string;
  nextResultAt: string;
  resultIntervalSeconds: number;
  weeklyStep: number;
  weeklySteps: number;
}

export interface BalanceSnapshotDto {
  id: string;
  cashCents: number;
  investedCents: number;
  totalCents: number;
  reason: string;
  createdAt: string;
}

export interface DashboardDto {
  account: AccountSummary;
  balance: BalanceSummary;
  transactions: LedgerEntryDto[];
  pendingRequests: MoneyRequestDto[];
  history: BalanceSnapshotDto[];
  instruments: InstrumentDto[];
  holdings: HoldingDto[];
}

export interface MeDto {
  user: AuthUser | null;
  csrfToken: string | null;
}
